import React, { useContext } from 'react';
import styled, { ThemeContext } from 'styled-components';
import ContactForm from './ContactForm';
import GotIdea from './GotIdea';
import Container from '../../../components/Container';
import DecorationsWhite from '../../../components/DecorationsWhite';
import useWindowWidth from '../../../hooks/useWindowWidth';


const ContactWrapper = styled.div`
  display: grid;
  grid-template-rows: repeat(2, auto);
  grid-template-columns: 1fr;
  
  @media(min-width: ${({ theme }) => theme.screenSizeWidth.large}) {
    grid-template-rows: 1fr;
    grid-template-columns: auto auto 1fr;
    grid-gap: 0 30px;
    padding-bottom: 70px;
  }
  
  @media(min-width: ${({ theme }) => theme.screenSizeWidth.extraLarge}) {
    grid-template-rows: 1fr;
    grid-template-columns: 1fr auto 1fr;
    grid-gap: 0 30px;
  }
`;

const DecorationWrapper = styled.div`
  position: relative;
`;

const ContactUs = () => {
  const themeContext = useContext(ThemeContext);
  const windowSize = useWindowWidth();

  return (
    <DecorationWrapper>
      {windowSize > 1200 && (
        <DecorationsWhite
          height="230px"
          width="30%"
          left="0"
          bottom="0"
          side="left"
        />
      )}
      <DecorationsWhite
        height={windowSize < 1000 ? '90%' : '260px'}
        width="30%"
        right="0"
        top={windowSize < 1000 ? '-20px' : '0'}
        side="right"
      />
      <Container
        backgroundColor={themeContext.colors.blue}
      >
        <ContactWrapper>
          <GotIdea />
          <ContactForm />
        </ContactWrapper>
      </Container>
    </DecorationWrapper>
  );
};

export default ContactUs;
